module.exports = __webpack_public_path__ + "img/Filter.c0e9e136.svg";